@if (src) {
  <ng-content></ng-content>
  @if (!isMobile || !mobileUrl) {
    <img
      [src]="src"
      [sizes]="sizes"
      [srcset]="srcset"
      [alt]="alt || ''"
      [attr.loading]="loading"
      [attr.fetchpriority]="fetchPriority"
      [width]="width"
      [height]="height"
      [style.max-width]="maxWidth ? maxWidth + 'px' : ''"
    />
  }
  @if (isMobile && mobileUrl) {
    <img
      [src]="mobileSrc"
      [srcset]="mobileSrcset"
      [alt]="alt || ''"
      [attr.loading]="loading"
      [attr.fetchpriority]="fetchPriority"
      [width]="mobileWidth || width"
      [height]="mobileHeight || height"
      [style.max-width]="maxWidth ? maxWidth + 'px' : ''"
    />
  }
}
